const routes = [
  // quickShifts
  {
    path: "/apps/pay-&-billing/quick-shifts-pending/",
    name: "apps-quick-shifts-pending",
    component: () => import('@/3-pay-&-billing/quick-shifts/pending/PikapalkkaPending.vue'),
    meta: {
      authRequired: true,
      resource: "pay-&-billing",
      action: "read"
    }
  },
  {
    path: "/apps/pay-&-billing/quick-shifts-sent/",
    name: "apps-quick-shifts-sent",
    component: () => import('@/3-pay-&-billing/quick-shifts/sent/PikapalkkaSent.vue'),
    meta: {
      authRequired: true,
      resource: "pay-&-billing",
      action: "read"
    }
  },
  {
    path: "/apps/pay-&-billing/quick-shifts-paying/",
    name: "apps-quick-shifts-paying",
    component: () => import('@/3-pay-&-billing/quick-shifts/paying/PikapalkkaPaying.vue'),
    meta: {
      authRequired: true,
      resource: "pay-&-billing",
      action: "read"
    }
  },
  // invoices
  {
    path: "/apps/pay-&-billing/invoices/list",
    name: "apps-invoices-list",
    component: () => import('@/3-pay-&-billing/invoices/invoice-list/InvoiceList.vue'),
    meta: {
      authRequired: true,
      resource: "pay-&-billing",
      action: "read"
    }
  },
  {
    path: "/apps/pay-&-billing/invoices/view/:id",
    name: "apps-invoices-view",
    component: () => import('@/3-pay-&-billing/invoices/invoice-preview/InvoicePreview.vue'),
    meta: {
      authRequired: true,
      resource: "pay-&-billing",
      action: "read"
    }
  },
  {
    path: "/apps/pay-&-billing/invoices/edit/:id",
    name: "apps-invoices-edit",
    component: () => import('@/3-pay-&-billing/invoices/invoice-edit/InvoiceEdit.vue'),
    meta: {
      authRequired: true,
      resource: "pay-&-billing",
      action: "write"
    }
  },
  // payrolls
  {
    path: "/apps/pay-&-billing/payrolls/list",
    name: "apps-payrolls-list",
    component: () => import('@/3-pay-&-billing/payrolls/payroll-list/PayrollList.vue'),
    meta: {
      authRequired: true,
      resource: "pay-&-billing",
      action: "read"
    }
  },
  {
    path: "/apps/pay-&-billing/payrolls/view/:id",
    name: "apps-payrolls-view",
    component: () => import('@/3-pay-&-billing/payrolls/payroll-preview/PayrollPreview.vue'),
    meta: {
      authRequired: true,
      resource: "pay-&-billing",
      action: "read"
    }
  },
  {
    path: "/apps/pay-&-billing/payrolls/edit/:id",
    name: "apps-payrolls-edit",
    component: () => import('@/3-pay-&-billing/payrolls/payroll-edit/PayrollEdit.vue'),
    meta: {
      authRequired: true,
      resource: "pay-&-billing",
      action: "write"
    }
  },
  // contracts
  {
    path: "/apps/pay-&-billing/contracts/list",
    name: "apps-contracts-list",
    component: () => import('@/3-pay-&-billing/contracts/contract-list/ContractList.vue'),
    meta: {
      authRequired: true,
      resource: "pay-&-billing",
      action: "read"
    }
  },
  {
    path: "/apps/pay-&-billing/contracts/view/:id",
    name: "apps-contracts-view",
    component: () => import('@/3-pay-&-billing/contracts/contract-view/ContractView.vue'),
    meta: {
      authRequired: true,
      resource: "pay-&-billing",
      action: "read"
    }
  },
  // campaigns
  {
    path: "/apps/pay-&-billing/campaigns/list",
    name: "apps-campaigns-list",
    component: () => import('@/3-pay-&-billing/campaigns/campaign-list/CampaignList.vue'),
    meta: {
      authRequired: true,
      resource: "pay-&-billing",
      action: "read"
    }
  },
  {
    path: "/apps/pay-&-billing/campaigns/view/:id",
    name: "apps-campaigns-view",
    component: () => import('@/3-pay-&-billing/campaigns/campaign-view/CampaignView.vue'),
    meta: {
      authRequired: true,
      resource: "pay-&-billing",
      action: "read"
    }
  }
]

export default routes